import { Component, OnInit, Optional, WritableSignal } from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { NonConformiteEntite } from '../../entites/non-conformite';
import { NonConformiteService } from '../../services/non-conformite-service';
import { BaseComponent } from '../../base/base-component';
import { DonneesBaseService } from '../../services/donnees-base-service';
import { ProfilService } from '../../services/profil-service';
import { Router } from '@angular/router';
import { AppMainComponent } from '../../app.main.component';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { EmplacementService } from '../../services/emplacement-service';
import { ViewChild } from "@angular/core";
import { EStatuts } from '../../entites/enums/statuts';
import { DocumentComponent } from '../documents/document.component';
import { ETypeLien } from '../../entites/enums/type-lien-document';
import { ApprobationComponent } from './approbation-non-conformite.component';
import { DialogService } from 'primeng/dynamicdialog';
import { DocumentEntite } from '../../entites/document';
import { ActionCorrectiveEntite } from '../../entites/action-corrective';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AjoutActionCorrectiveComponent } from './ajout-action-corrective.component';
import { EmployeEntite } from "src/app/entites/employe";
import { EmployeService } from "src/app/services/employe-service";
import { environment } from "src/environments/environment";
import { Fournisseur } from "src/app/entites/fournisseur";
import { FournisseurService } from "src/app/services/fournisseur-service";
import { RapportService } from "src/app/services/rapport-service";

@Component({
  selector: 'app-detail-non-conformite',
  templateUrl: './detail-non-conformite.component.html',
  styleUrl: './detail-non-conformite.component.scss',
  providers: [MessageService, ConfirmationService, NonConformiteService, DialogService]
})
export class DetailNonConformiteComponent extends BaseComponent implements OnInit {
  modePopup: boolean = false;
  nonConformite: NonConformiteEntite;
  actionCorrectives: ActionCorrectiveEntite[];
  documents: DocumentEntite[];
  nonConformiteId: number;
  tabIndex: WritableSignal<number> = this.createParamSignal('tab', 0);
  menu: any[];
  types: any[];
  codeProjets: any[];
  chargementCompleteDocuments: boolean = false;
  chargementCompleteActionCorrective: boolean = false;
  fournisseurs: Fournisseur[];
  employes: EmployeEntite[];
  typeDocumentSelectionne: string;

  @ViewChild('tabView') tabView;
  @ViewChild(DocumentComponent) docView: DocumentComponent;

  constructor(
    sdb: DonneesBaseService,
    profilService: ProfilService,
    route: ActivatedRoute,
    appMain: AppMainComponent,
    private nonConformiteService: NonConformiteService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    public routerService: Router,
    private emplacementService: EmplacementService,
    private dialogService: DialogService,
    private employeService: EmployeService,
    private confirmationService: ConfirmationService,
    private fournisseurService: FournisseurService,
    private rapportService: RapportService,
    @Optional() private config: DynamicDialogConfig
  ) {
    super(sdb, profilService, route, routerService, appMain);

    if (!this.modePopup) {
      this.breadcrumbService.setItems([
        { label: 'Non-conformités', routerLink: '/assurancequalite/nonconformite' },
        { label: 'Détails' }
      ]);
    }
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.nonConformiteId = params['id'];
      } else {
        this.nonConformiteId = this.config.data;
        this.modePopup = true;
      }

      var promises = [];
      promises.push(this.emplacementService.ObtenirCodeProjets().then(
        (result) => {
          this.codeProjets = result.valeur;
        },
        (error) => {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération du code projet' });
        }
      ));

      promises.push(this.nonConformiteService.ObtenirDetail(this.nonConformiteId).then(
        (data) => {
          this.nonConformite = data.valeur;
          this.fournisseurService.ObtenirFournisseurs().then(
            (result) => {
              this.fournisseurs = result.valeur;
    
              if (this.nonConformite?.sousTraitant?.fournisseurId) {
                this.nonConformite.sousTraitant = this.fournisseurs.find(f => f.fournisseurId === this.nonConformite.sousTraitant.fournisseurId);
              } else {
                this.nonConformite.sousTraitant = null;
              }
            },
            (error) => {
              this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération des fournisseurs' });
            }
          );
        },
        (error) => {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors du chargement de la non-conformité' });
        }
      ));

      this.employeService.ObtenirListe().then(
        (result) => {
          this.employes = result.valeur;
        },
        (error) => {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération des employés' });
        }
      );

      Promise.all(promises).then(() => {
        this.initialiserMenu();

        this.fournisseurService.ObtenirFournisseurs().then(
          (result) => {
            this.fournisseurs = result.valeur;
          },
          (error) => {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération des fournisseurs' });
          }
        );

        this.types = [{ id: 'Q', nom: 'Qualité' }, { id: 'S', nom: 'SST' }, { id: 'E', nom: 'Environnement' }];

        if (this.nonConformite.dateEmission) {
          this.nonConformite.dateEmission = new Date(this.nonConformite.dateEmission);
        }
        if (this.nonConformite.dateDetection) {
          this.nonConformite.dateDetection = new Date(this.nonConformite.dateDetection);
        }

        this.CompleterChargement();
      });
    });
  }

  initialiserMenu() {
    this.menu = [
      {
        label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back()
      },
      {
        label: 'Imprimer', icon: 'pi pi-fw pi-print', command: () => this.imprimer()
      },
      {
        label: 'Partager', icon: 'pi pi-fw pi-share-alt', command: () => this.partager()
      },
      {
        label: 'Actions', icon: 'pi pi-fw pi-bars',
        items: [
          {
            label: 'Demande d\'action corrective', icon: 'pi pi-fw pi-file-check', command: () => this.actionCorrective(),
            visible: this.nonConformite.statut.statutId != EStatuts.Nouveau && this.nonConformite.employe?.employeId != this.profilService.ProfilCourant().employeId
          },
          {
            label: 'Traiter et approuver', icon: 'pi pi-fw pi-check-circle', command: () => this.traitement(),
            visible: this.nonConformite.statut.statutId == EStatuts.Nouveau
          },
          {
            label: 'Modifier le traitement', icon: 'pi pi-fw pi-pencil', command: () => this.traitement(),
            visible: this.nonConformite.statut.statutId == EStatuts.Traite
          },
          { separator: true },
          {
            label: 'Archiver', icon: 'pi pi-fw pi-folder-open',
            visible: /*this.estAutorise('nonconformite_action_archiver') &&*/ this.nonConformite.statut.statutId != EStatuts.Archive,
            command: () => this.archiver()
          },
          {
            label: 'Désarchiver', icon: 'pi pi-fw pi-folder-open',
            visible: this.nonConformite.statut.statutId == EStatuts.Archive,
            command: () => this.desarchiver()
          },
          { separator: true },
          {
            label: 'Supprimer', icon: 'pi pi-fw pi-trash',
            disabled: !this.modeConsultation(),
            visible: this.hasRole('SIHC_Administrateur'),
            command: () => this.supprimer()
          }
        ]
      },
    ];
  }

  actionCorrective() {
    this.dialogService.open(AjoutActionCorrectiveComponent, {
      header: 'Ajout d\'action corrective',
      width: '80%',
      contentStyle: { 'overflow': 'visible' },
      data: this.nonConformite.idNonConformite
    }).onClose.subscribe((result) => {
      if (result) {
        this.routerService.navigate(['/assurancequalite/actioncorrective/' + result.actionCorrectiveId]);
      } else {
        this.breadcrumbService.setItems([
          { label: 'Non-conformités', routerLink: '/assurancequalite/nonconformite' },
          { label: 'Détails' }
        ]);
      }
    });
  }

  voirActionCorrective(actionCorrectiveId: number) {
    this.routerService.navigate(['/assurancequalite/actioncorrective/' + actionCorrectiveId]);
  }

  traitement() {

    this.dialogService.open(ApprobationComponent, {
      header: 'Traitement de la Non-Conformité',
      width: window.innerWidth < 768 ? '97%' : '50%',
      contentStyle: { overflow: 'visible' },
      closeOnEscape: true,
      data: {
        nonConformite: this.nonConformite
      }
    }).onClose.subscribe((result) => {
      if (result) {
        this.nonConformite = result;
      }
    });
  }

  VoirDocumentsTraitement() {
    this.tabIndex.set(3);

    this.typeDocumentSelectionne = "traitement_nc";
  }

  retour() {
    this.routerService.navigateByUrl('assurancequalite/nonconformite');
  }

  archiver() {
    this.confirmationService.confirm({
      message: 'Voulez-vous vraiment archiver cette non-conformité ?',
      accept: () => {
        this.nonConformiteService.Archiver(this.nonConformiteId).then(
          (result) => {
            this.retour();
          },
      (error) => {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de l\'archivage de la non-conformité' });
          }
        );
      }
    });
  }

  desarchiver() {
    this.nonConformiteService.DeArchiverNonConformite(this.nonConformiteId).then(
      (result) => {
        this.retour();
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la désarchivage de la non-conformité' });
      }
    );
  }

  marquerComplet() {
    // Implement the logic to mark the non-conformity as complete
  }

  enregistrerModifications() {
    this.nonConformiteService.Modifier(this.nonConformite).then(
      (result) => {
        this.Consulter();
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'La non-conformité a été modifiée avec succès' });
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la modification de la non-conformité' });
      }
    );
  }

  chargerActionCorrective() {
    this.nonConformiteService.ObtenirActionCorrectivesParNonConformite(this.nonConformite.idNonConformite).then(
      (result) => {
        this.actionCorrectives = result.valeur;
        this.chargementCompleteActionCorrective = true;
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération des actions correctives' });
      }
    );
  }

  supprimer() {
    this.confirmationService.confirm({
      message: 'Voulez-vous vraiment supprimer cette non-conformité ?',
      accept: () => {
        this.nonConformiteService.Supprimer(this.nonConformiteId).subscribe(
          (result) => {
            this.retour();
      },
      (error) => {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la suppression de la non-conformité' });
          }
        );
      }
    });
  }

  surChangementOnglet(index: number) {
    this.tabIndex.set(index);
    const header = this.tabView?.tabs?.[this.tabIndex()]?._header ?? '';
    if (header.startsWith('Suivi') && !this.chargementCompleteActionCorrective) {
      this.chargerActionCorrective();
    }
  }

  public get ETypeLienDocument(): typeof ETypeLien {
    return ETypeLien;
  }

  public get EStatuts(): typeof EStatuts {
    return EStatuts;
  }

  copierDateEmission() {
    if (this.nonConformite.dateEmission) {
      this.nonConformite.dateDetection = new Date(this.nonConformite.dateEmission);
    }
  }

  partager() {
    navigator.share({
      title: 'SIHC - Non-conformité',
      text: 'Non-conformité #' + this.nonConformite.idNonConformite,
      url: environment.urlBase + '/assurancequalite/nonconformite/' + this.nonConformite.idNonConformite
    });
  }

  imprimer() {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Le rapport est en cours de production...' });
    this.rapportService.ProduireRapportNonConformite(this.nonConformiteId).then(
      (result) => {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le rapport a été produit avec succès' });
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la production du rapport' });
      }
    );
  }
}